import React, { Suspense, useContext, useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect, useHistory } from 'react-router-dom';
import { QueryClient, QueryClientProvider, useQuery } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Loggedincontext } from './Loggedincontext.js';
import { Routedispatcherprovider } from './Routedispatcher';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import './trans.css';
import { Contexthandlerscontext_provider } from './Contexthandlerscontext';
import { fetchAuthorization_API } from './components/API/API';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { Modal } from 'react-bootstrap';
import { IoMdClose } from 'react-icons/io';
import { serverbaselink } from './Env_Variables';
import CircularProgress from 'react-cssfx-loading/lib/CircularProgress';

const Websiterouter = React.lazy(() => import('./components/Website/Websiterouter'));

const App = (props) => {
    const [openModal, setopenModal] = useState(false);

    const { fetchuseauthorizationQueryContext } = useContext(Loggedincontext);
    axios.interceptors.request.use(function (config) {
        const cookies = new Cookies();

        var defaultheaders = config.headers;
        var token = cookies.get('12312easdasdas32131asdsadsadsaqweasd123!@_#!@3123');
        if (token != undefined) {
            defaultheaders.Authorization = 'Bearer ' + token;
        }

        config.headers = defaultheaders;
        return config;
    });
    let history = useHistory();
    const { userloggedinfobjcontext, setuserloggedinfobjcontext, isloggedincontext, setisloggedincontext } = React.useContext(Loggedincontext);
    useEffect(() => {
        if (fetchuseauthorizationQueryContext.isSuccess) {
            setisloggedincontext(fetchuseauthorizationQueryContext.data.data.loggedin);
            if (fetchuseauthorizationQueryContext.data.data.loggedin) {
                var tempuserloggedinfo = { ...userloggedinfobjcontext };
                tempuserloggedinfo.userinfo = { ...fetchuseauthorizationQueryContext.data.data.userinfo };
                setuserloggedinfobjcontext({
                    ...tempuserloggedinfo,
                });
            }
            if (fetchuseauthorizationQueryContext.data.data.instinfo.haspopupad == 1) {
                setopenModal(true);
            }
        }
    }, [fetchuseauthorizationQueryContext.isSuccess]);

    return (
        <Contexthandlerscontext_provider>
            <Router>
                <Routedispatcherprovider>
                    <div style={{ height: '100%', width: '100%', background: 'white' }}>
                        <Suspense
                            fallback={
                                <div
                                    style={{
                                        height: '100%',
                                        width: '100%',
                                        position: 'absolute',
                                        backgroundColor: 'white',
                                    }}
                                    class="row w-100 m-0 d-flex justify-content-center"
                                >
                                    <div class="col-lg-12 d-flex justify-content-center align-items-center"></div>
                                </div>
                            }
                        >
                            <Websiterouter />
                            {/* <Route
                                render={({ location, match }) => {
                                    return (
                                        <TransitionGroup>
                                            <Switch key={location.key} location={location}>
                                                <Route
                                                    path="/"
                                                    render={() => {
                                                        return <Websiterouter />;
                                                    }}
                                                />
                                            </Switch>
                                        </TransitionGroup>
                                    );
                                }}
                            /> */}
                            <Modal size="xl" show={openModal} onHide={() => setopenModal(false)}>
                                {fetchuseauthorizationQueryContext.isFetching && (
                                    <div style={{ height: '50vh' }} class="row w-100 allcentered m-0">
                                        <CircularProgress color="var(--primary)" width="60px" height="60px" duration="1s" />
                                    </div>
                                )}
                                {fetchuseauthorizationQueryContext.isSuccess && !fetchuseauthorizationQueryContext.isFetching && (
                                    <>
                                        <div class={'close-modal-container ml-auto'} onClick={() => setopenModal(false)}>
                                            <IoMdClose size={24} />
                                        </div>

                                        <Modal.Body>
                                            <div className={'row m-0 p-0 w-100'}>
                                                <img
                                                    src={serverbaselink + fetchuseauthorizationQueryContext.data.data.instinfo.popadurlimage}
                                                    style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '10px' }}
                                                />
                                            </div>
                                        </Modal.Body>
                                    </>
                                )}
                            </Modal>
                        </Suspense>
                    </div>
                </Routedispatcherprovider>
            </Router>
            <NotificationContainer />
            <ReactQueryDevtools initialIsOpen />
        </Contexthandlerscontext_provider>
    );
};

export default App;
